// src/assets/js/home/homeFavorites.js
// Favoritos (Landing SEO)
// - Lee/escribe en localStorage una lista de quizzes favoritos
// - Esquema: { quizId: HASH, subjectId, subjectTitle, quizTitle }
// - Key: quizId (único en la app)
// - Límite UI: 9 favoritos (si se supera, hace "shake" al botón)

const MAX_FAVS = 9;
const SHAKE_CLASS = 'is-shaking';
const SHAKE_MS = 420;

function safeParse(json, fallback) {
	try {
		return JSON.parse(json);
	} catch {
		return fallback;
	}
}

function normalizeFav(item) {
	return {
		quizId: String(item?.quizId || '').trim(),
		subjectId: String(item?.subjectId || '').trim(),
		subjectTitle: String(item?.subjectTitle || '').trim(),
		quizTitle: String(item?.quizTitle || '').trim(),
	};
}

function loadFavs(storageKey) {
	const raw = localStorage.getItem(storageKey);
	const data = safeParse(raw, { quizzes: [] });
	const quizzes = Array.isArray(data?.quizzes) ? data.quizzes : [];

	// Normalizamos estructura: [{quizId, subjectId, subjectTitle, quizTitle}]
	return (
		quizzes
			.map(normalizeFav)
			// quizId es obligatorio (es la key)
			.filter((q) => q.quizId)
	);
}

function saveFavs(storageKey, favs) {
	localStorage.setItem(storageKey, JSON.stringify({ quizzes: favs }));
}

function keyOf({ quizId }) {
	return quizId;
}

function setStarIcon(btn, isFav) {
	const icon = btn.querySelector('i');
	if (!icon) return;

	// FontAwesome: regular = vacío, solid = lleno
	icon.classList.toggle('fa-regular', !isFav);
	icon.classList.toggle('fa-solid', isFav);

	btn.setAttribute('aria-pressed', String(isFav));
}

function shake(el) {
	if (!el) return;

	// Reinicia animación si se dispara seguido
	el.classList.remove(SHAKE_CLASS);
	// Forzar reflow
	// eslint-disable-next-line no-unused-expressions
	el.offsetWidth;
	el.classList.add(SHAKE_CLASS);

	window.setTimeout(() => {
		el.classList.remove(SHAKE_CLASS);
	}, SHAKE_MS);
}

export function initHomeFavorites({ root = document, storageKey } = {}) {
	if (!storageKey) return;

	const favButtons = Array.from(root.querySelectorAll('[data-action="fav-quiz"]'));
	if (favButtons.length === 0) return;

	let favs = loadFavs(storageKey);
	const favSet = new Set(favs.map(keyOf));

	// Pintado inicial
	favButtons.forEach((btn) => {
		const quizId = String(btn.dataset.quizId || '').trim();

		if (!quizId) {
			btn.disabled = true;
			setStarIcon(btn, false);
			return;
		}

		setStarIcon(btn, favSet.has(quizId));
	});

	// Toggle
	favButtons.forEach((btn) => {
		btn.addEventListener('click', () => {
			const quizId = String(btn.dataset.quizId || '').trim();
			if (!quizId) return;

			const subjectId = String(btn.dataset.subjectId || '').trim();
			const subjectTitle = String(btn.dataset.subjectTitle || '').trim();
			const quizTitle = String(btn.dataset.quizTitle || '').trim();

			const isFav = favSet.has(quizId);

			// Quitar favorito
			if (isFav) {
				favSet.delete(quizId);
				favs = favs.filter((f) => f.quizId !== quizId);
				saveFavs(storageKey, favs);
				setStarIcon(btn, false);
				return;
			}

			// Añadir favorito (con límite UI)
			if (favSet.size >= MAX_FAVS) {
				shake(btn);
				return;
			}

			favSet.add(quizId);

			// Guardamos también subjectId + títulos (para import y "Mis Materias")
			const favItem = { quizId, subjectId, subjectTitle, quizTitle };

			favs = [...favs.filter((f) => f.quizId !== quizId), favItem];

			saveFavs(storageKey, favs);
			setStarIcon(btn, true);
		});
	});
}
